/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import JSG from '@cedalo/jsg-ui';
import { graphManager } from '../../../GraphManager';
import { useJSGNotification } from '../../utils/JSGHooks';
import DialogButton from '../../utils/DialogButton';
import Divider from '@mui/material/Divider';

export default function DecisionDialog() {
	const [open, setOpen] = useState(false);
	const [clipData, setClipData] = useState(null);

	const onSheetMessage = (notification) => {
		if (notification.object && notification.object.action === 'pastecells') {
			setOpen(true);
			setClipData(JSG.clipSheet.data);
		}
	};

	useJSGNotification(JSG.WorksheetView.SHEET_ACTION_NOTIFICATION, onSheetMessage);

	const handleClose = () => {
		setOpen(false);
		const sheetView = graphManager.getActiveSheetView();
		if (sheetView) {
			sheetView.pasteFromClipboard(
				graphManager.getGraphEditor().getGraphViewer(),
				sheetView._clipTarget,
				clipData,
				'all',
				false,
				true
			);
		}
	};

	const handleCancel = () => setOpen(false);

	return (
		<div>
			<Dialog open={open} onClose={handleCancel} /* onEscapeKeyDown={handleCancel} */>
				<DialogTitle>
					<FormattedMessage id="Dialog.Warning" defaultMessage="Warning" />
				</DialogTitle>
				<DialogContent
					style={{
						margin: '20px'
					}}
				>
					<DialogContentText>
						<FormattedMessage
							id="DialogDecision.PasteOverwrite"
							defaultMessage="The target range contains values! Do you want to overwrite these?"
						/>
					</DialogContentText>
				</DialogContent>
				<Divider />
				<DialogActions>
					<DialogButton margin onClick={handleCancel}>
						<FormattedMessage id="Dialog.Cancel" defaultMessage="Cancel" />
					</DialogButton>
					<DialogButton defaultButton margin onClick={handleClose}>
						<FormattedMessage id="Dialog.OK" defaultMessage="OK" />
					</DialogButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
